var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[_vm._v("\n  Job status manually changed to\n  "+_vm._s(_vm.$lodash.get(_vm.activity, "detail.job.status"))+"\n\n  "),_c('job-object',{attrs:{"job-number":_vm.activity.job_id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }